import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Label from '@/shared/ui/elements/label/Label';
import { getModifiers } from '@/shared/ui/core';

import { Wrapper, TextareaStyled } from './TextArea.styled';

const labelModifiers = ['default', 'required'];

const Textarea = (
  { name, modifiers, outLabel, placeholder, maxLength, ...props },
  ref,
) => {
  const textareaRef = React.useRef(ref);

  const charactersLength = textareaRef.current?.value?.length;

  return (
    <>
      {outLabel && (
        <Label
          content={outLabel}
          modifiers={getModifiers(props, labelModifiers)}
        />
      )}
      <Wrapper>
        <TextareaStyled
          ref={textareaRef}
          name={name}
          innerRef={ref}
          modifiers={modifiers}
          placeholder={placeholder}
          maxLength={maxLength}
          as="textarea"
          {...props}
        />
        {maxLength && <span>{`${charactersLength}/${maxLength}`}</span>}
      </Wrapper>
    </>
  );
};

Textarea.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  outLabel: PropTypes.string,
};

Textarea.defaultProps = {
  modifiers: [''],
  placeholder: '',
  outLabel: '',
};

export default React.forwardRef((props, ref) => <Field as={Textarea} ref={ref} {...props} />);
